import * as globals from './globals'; //jshint ignore:line

// Get mobile button
const leftNav = document.querySelector('.secondary-nav');
let leftNavTitle = document.querySelector('.secondary-nav h2');

// Create mobile toggle button
if(leftNavTitle){
	leftNavTitle = leftNavTitle.innerHTML;
	let btn = document.createElement("BUTTON");
	btn.classList.add('mobile-toogle-btn');
	btn.setAttribute('type','button');
	btn.innerHTML = leftNavTitle;
	let wrapper = document.querySelector(".mobile-button-target");
	wrapper.appendChild(btn);
}

var toggleMenu = () => {
  if(leftNav.classList.contains('active')){
    leftNav.classList.remove('active');
  } else {
    leftNav.classList.add('active');
  }
}

const toggleBtn = document.querySelector('.mobile-toogle-btn');
if(toggleBtn){
  toggleBtn.addEventListener('click', toggleMenu);
}



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/left-nav.js